import { WidgetInstance } from 'friendly-challenge'

/**
 * Widget callback function for login button toggling.
 */
const widgetCallback = () => {
  document.getElementById('login-submit-btn')?.removeAttribute('disabled')
}

export default (startMode: 'auto' | 'focus' | 'none' = 'focus') =>
  () => {
    const container = document.querySelector<HTMLElement>('.frc-captcha')

    if (!container) {
      return
    }

    new WidgetInstance(container, {
      startMode,
      doneCallback: widgetCallback,
      errorCallback: widgetCallback,
    })
  }
